import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        primary: "#0d0d0d",
        secondary: "#b0bec5",
        accent: "#040bc8",
        error: "#ee3538",
      },
    },
  },
};

export default new Vuetify(opts);
